module.exports = __webpack_public_path__ + "static/img/a1.16c119b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/a1.png
// module id = J6Nf
// module chunks = 1